/**
 * TRAD-3867 — 인사이트(Insights) 섹션. 🔸 10/30 davidyoon «인사이트» 별도 섹션 → `/finance` → `/insights` 로 옮겼다(계약 v6 §7 web 줄).
 * `/finance` 는 dev 에만 배포됐던 주소라(운영 미배포 — SEO 영향 0) 리다이렉트만 남긴다(`legacyFinance*`).
 * 🔴 앱 웹뷰(iOS·Android)가 `/insights/{slug}?src=app&embed=1&theme=` 와 `#map`·`#table` 을 이 주소에 맞춘다 — 바꾸면 3사 동시.
 */
export const financeRoutePaths = {
  finance: {
    path: 'insights',
    url: '/insights',
  },
  financeContent: {
    path: 'insights/:slug',
  },
  /** 관계 지도·표(10/30 22:2x 목록에서 분리). 정적 경로라 `insights/:slug` 보다 우선한다(React Router 랭킹). */
  financeRelations: {
    path: 'insights/relations',
    url: '/insights/relations',
  },
  /** 공유(캡처) 카드 — MainLayout 밖 · noindex(팀장 10/30). marketer relation-card.py 가 `[data-card="pair"]` 를 여기서 잡는다. */
  financeShareCard: {
    path: 'insights/:slug/card',
  },
  /**
   * TRAD-3921 — 영어판 주소(설계 docs-ops/2026-11-05-insight-bilingual-design.md §3 «주소가 글의 언어를 정한다»). 화면은 한국어 주소와 같은 컴포넌트다
   * — 글 언어·화면 언어는 주소에서 읽는다(`entities/finance-content/lib/content-lang.ts` · `i18n/locale.ts` `pathLocale`).
   * 🔴 앱 웹뷰는 이 주소를 쓰지 않는다(`/insights…?embed=1` 그대로 · 기기 언어로 고른다) — 임베드 경로 정규식(embed-view.ts · index.html)도 그대로다.
   */
  financeEn: {
    path: 'en/insights',
    url: '/en/insights',
  },
  financeContentEn: {
    path: 'en/insights/:slug',
  },
  financeRelationsEn: {
    path: 'en/insights/relations',
    url: '/en/insights/relations',
  },
  financeShareCardEn: {
    path: 'en/insights/:slug/card',
  },
  legacyFinance: {
    path: 'finance',
  },
  legacyFinanceContent: {
    path: 'finance/:slug',
  },
} as const;

/** `/insights/<slug>/card` · `/en/insights/<slug>/card`(끝 슬래시 허용) — RootLayout 이 쿠키 배너를 안 띄우는 판정. 순수 함수. */
export const isInsightsShareCardPath = (pathname: string): boolean =>
  /^(\/en)?\/insights\/[^/]+\/card\/?$/.test(pathname);
